import { forwardRef } from 'react';
import MuiSlider, { type SliderProps as MuiSliderProps } from '@mui/material/Slider';

export type SliderProps = MuiSliderProps;

export const Slider = forwardRef<HTMLSpanElement, SliderProps>(
  ({ color = 'primary', ...rest }, ref) => <MuiSlider ref={ref} color={color} {...rest} />
);

Slider.displayName = 'Slider';
